import {TimeStream} from '../utils';


const defaults = {
	globalIndex: 1,
	discusses: [],
    writing: false,
    draft: '',
	lecture: null
};


const appendDiscuss = (state, payload) => {
	var m = {
		id: payload.timestamp,
		type: payload.type,
		account: payload.account,
		timestamp: payload.timestamp,
		create_time: TimeStream(Date.parse(new Date()) / 1000)
	};

	if(m.type === 'discuss_text'){
		m.content = payload.content
	}
	return [m, ...state.discusses]
};


export default (state=defaults, action) => {
	switch(action.type){
		case 'DISCUSS_INIT':
			return {...state, 
				discusses: [],
				lecture: action.payload.lecture
			}
		case 'DISCUSS_APPEND':
			return {...state, 
				discusses: [...state.discusses, ...action.payload.discusses]
			}
		case 'DISCUSS_SEND':{
			const discusses = appendDiscuss(state, action.payload);
			return {...state, discusses: discusses, globalIndex: state.globalIndex+1}
		}
		case 'DISCUSS_TOGGLE':{
			const discusses = state.discusses.map(m => {
				if(m.id === action.payload.id){
					var update = {published: action.payload.published}
					if(action.payload.discuss){
						update = {...update, ...action.payload.discuss}
					}
					return {...m, ...update}
				}
				return m
			})
			return {...state, discusses: discusses}
		}
		case 'DISCUSS_DELETE':{
			const discusses = state.discusses.filter(m=>m.id !== action.payload.id)
			return {...state, discusses: discusses}
		}
		case 'DISCUSS_RECEIVE':
			action.payload.receive_timestamp = Date.now() * 0.001;
			return {...state, discusses: [...state.discusses, action.payload]}
		case 'DISCUSS_SHOW_WRITING':
			return {...state, writing: true}
		case 'DISCUSS_HIDE_WRITING':
			return {...state, writing: false}
		case 'DISCUSS_UPDATE_DRAFT':
			return {...state, draft: action.payload}
		case 'PAGE_INIT':
			return {...state, discusses: [], lecture: null}
		default:
			return state
	}
}





// WEBPACK FOOTER //
// ./src/reducers/discussList.js